export const TRANSLATIONS_EN = {
  booking: {
    accepted: 'Accepted',
    bookingRequest: 'Booking Request',
    cancelledByFP: 'Cancelled by FP',
    filterLabelPax: 'Filter by Pax Agency',
    inputSearch: 'Search by email',
    messageBookingAccepted: 'Booking has already been accepted',
    messageBookingRejected: 'Booking was rejected',
    notProcessed: 'Not Processed',
    pickup: 'Pickup',
    processed: 'Processed',
    rejected: 'Rejected',
    request: 'Request',
    time: 'Time',
    userCancelled: 'User Cancelled',
  },
  bookingDetails: {
    bookingRequestor: 'Booking requestor',
    btnConfirmAccepting: 'Confirm Accepting',
    btnReject: 'Reject',
    btnRejectNow: 'Reject Now',
    btnShowPreview: 'Show Preview',
    chooseTime: 'Choose time',
    dropoffAt: 'Dropoff At',
    dropoffDate: 'Drop-off Date',
    dropoffLocation: 'Drop-off Location',
    dropoffTime: 'Drop-off Time',
    dropoffTown: 'Drop-off Town',
    errorMessage: 'Booking Details were not found',
    estimatedDropoffTime: 'Estimated Drop-off time',
    flightArrivalDepartureTime: 'Flight arrival departure time',
    leg: 'Leg',
    messageConflictingDrives: 'has other drives for this time period. Please select other',
    messageConflictingMulti: 'has other drives for this time period. Please select another driver',
    messageDriveAccepted: 'Drive has already been accepted',
    messageUpdateBooking: 'Booking was successfully updated',
    outward: 'Outward',
    outwardTrip: 'Outward trip',
    pickupAt: 'Pickup At',
    pickupDate: 'Pick-up Date',
    pickupLocation: 'Pick-up Location',
    pickupTime: 'Pick-up Time',
    pickupTown: 'Pick-up Town',
    processTrip: 'Process trip',
    requestingUnit: 'Requesting Unit',
    return: 'Return',
    returnTime: 'Return Time',
    returnTrip: 'Return trip',
    selected: 'Selected',
    showBookingRequestorDetails: 'Show booking requestor details',
    signatureCode: 'Signature code',
    step1: 'Step 1: Process outward trip',
    step2: 'Step 2: Process return trip',
    title: 'Booking details',
    viewBookingDetails: 'View Booking Details',
  },
  bookingList: {
    bookingForwarded: 'Booking forwarded',
    btnExport: 'Export by selected range',
    btnExportCurrentView: 'Export Current View',
    errorMessage: 'No booking for this period',
    modalTitle: 'Choose the export range by booking request',
    title: 'Booking Status list for',
  },
  checklist: {
    checkInformation: 'Check information',
    remarksFromManager: 'Remarks from Transportation Manager',
    statusChecklist: 'Status checklist',
    unknownDriver: 'Unknown driver',
  },
  common: {
    agencies: 'Agencies',
    agency: 'Agency',
    agencyName: 'Agency name',
    agencyPax: 'Agency Pax',
    agencySelectLabel: 'Your are visiting this as',
    airport: 'Airport',
    allAgencies: 'All Agencies',
    allMonths: 'All months',
    allYears: 'All years',
    amount: 'Amount',
    armoured: 'Armoured',
    averageRating: 'Average Rating',
    booking: 'Booking',
    btnBack: 'Back',
    btnBackToList: 'Back to List',
    btnCalculateNow: 'Calculate Now',
    btnCancel: 'Cancel',
    btnChange: 'Change',
    btnConfirm: 'Confirm',
    btnConfirmChanges: 'Confirm Changes',
    btnConfirmDates: 'Confirm Dates',
    btnDone: 'Done',
    btnDownload: 'Download',
    btnDownloadInvoice: 'Download Invoice',
    btnEdit: 'Edit',
    btnExport: 'Export',
    btnExportData: 'Export Data',
    btnNext: 'Next',
    btnResetFilters: 'Reset Filters',
    btnSave: 'Save',
    btnVerify: 'Verify',
    btnView: 'View',
    carpooled: 'Carpooled',
    changeEmail: 'Change Email',
    changePhoneNumber: 'Change Phone Number',
    city: 'City',
    click: 'Click',
    costRecoveryReport: 'Cost Recovery Report',
    country: 'Country',
    currency: 'Currency',
    customerSatisfaction: 'Customer Satisfaction',
    daily: 'Daily',
    delete: 'Delete',
    description: 'Description',
    documents: 'Documents',
    downloadCSV: 'Download CSV',
    driver: 'Driver',
    drivers: 'Drivers',
    duration: 'Duration',
    editDrive: 'Edit Drive',
    email: 'Email',
    emptyList: 'Empty list',
    errorMessageDefault: 'Something went wrong',
    errorMessageDateRange: 'The specified date range is not valid',
    errorMessageGps: 'Impossible to connect!',
    fieldRequired: 'This field is required',
    financials: 'Financials',
    firstName: 'First Name',
    fleetManagement: 'Fleet Management',
    flightNumber: 'Flight number',
    from: 'from',
    fromIncluded: 'From (included)',
    greenFund: 'Green fund',
    indexNumber: 'Index Number',
    info: 'Info',
    inputEndDate: 'End Date',
    inputEndTime: 'End Time',
    inputStartDate: 'Start Date',
    inputStartTime: 'Start Time',
    inTown: 'In-Town',
    lastName: 'Last Name',
    lastUpdate: 'Last update',
    manuals: 'Manuals',
    mobilityPlanner: 'Mobility Planner',
    mobilityLogbook: 'Mobility Logbook',
    mobilityLogbookDetails: 'Details Trip Page',
    month: 'Month',
    myMobility: 'My Mobility',
    name: 'Name',
    no: 'No',
    note: 'Note',
    number: 'Number',
    outOfTown: 'Out of Town',
    passenger: 'Passenger',
    passengers: 'Passengers',
    pax: 'Pax',
    paxAgency: 'Pax Agency',
    paymentMethod: 'Payment method',
    phoneNumber: 'Phone Number',
    photo: 'Photo',
    price: 'Price',
    rangeEnd: 'Range End',
    rangeStart: 'Range Start',
    recurring: {
      addRecurring: 'Add recurring drive',
      addRecurringBtn: 'Add Recurring',
      allDays: 'All days',
      cancelRecurringBtn: 'Cancel Recurring',
      conflictMessage1: 'This recurring drive is conflicting with another drive',
      conflictMessage2: 'created for the same time period',
      dailyFrequency: 'Daily frequency',
      dailyRecurringDrive: 'Daily recurring drive',
      drive: 'Recurring drive',
      drivesOverview: 'The following drives will be created',
      forceCreate: {
        adviceMessage:
          'You can proceed with creating this recurring, but afterwards, it is recommended to assign the conflicting drive to another driver.',
        conflictingDrives: 'There are conflicting drives for the recurring period selected',
        continuePrompt:
          'Click YES if you still want to create a recurring drive or click NO to dismiss.',
        title: 'Create Recurring Drive',
      },
      formatRecurringConflict: 'There is a conflict for driver',
      isRecurring: 'Is Recurring',
      onlyWorkingDays: 'Only working days',
      repeatDrive: 'Repeat this drive',
      repeatUntil: 'Until(max 30 days from pick-up date)',
      successMessage: 'Recurring drive was successfully created',
      type: 'Recurring type',
      weeklyRecurringDrive: 'Weekly recurring drive',
      workingDaysFromMonday: 'Only working days (Monday - Friday)',
      workingDaysFromSunday: 'Only working days (Sunday - Thursday)',
    },
    recurringDrive: 'Recurring drive',
    remarks: 'Remarks',
    reportingArea: 'Reporting Area',
    rideshared: 'Rideshared',
    sameDay: 'Same day',
    select: 'Select',
    serviceCostSettings: 'Service Cost Settings',
    showAll: 'Show all',
    soft: 'Soft',
    status: 'Status',
    surname: 'Surname',
    to: 'to',
    toIncluded: 'To (included)',
    total: 'Total',
    trainings: 'Trainings',
    transferType: 'Transfer Type',
    trips: 'Trips',
    typeOfTrip: 'Type of trip',
    unit: 'Unit',
    username: 'Username',
    vehicle: 'Vehicle',
    vehicleTrackingSystem: 'Vehicle Tracking System',
    vendorNumber: 'Vendor Number',
    weekly: 'Weekly',
    when: 'When',
    year: 'Year',
    yes: 'Yes',
  },
  crumbs: {
    bookingDetails: 'Booking Details',
    bookings: 'Bookings',
    bookingsList: 'Bookings List',
    countryReport: 'Country Report',
    createAgencyInvoice: 'Create Agency Invoice',
  },
  feedback: {
    btnConfirmRemark: 'Confirm remark',
    btnExportPending: 'Export Pending CSV File',
    btnExportReviewed: 'Export Reviewed CSV File',
    btnForward: 'Forward to admin office',
    comment: 'comment',
    commentAndRemark: 'comment and remark',
    close: 'Close',
    closed: 'Closed',
    confirmOrEditRemark: 'Confirm or edit Remark',
    dateOfRide: 'Date of ride',
    forwardForAction: 'Forward for action',
    inputAdminEmail: 'Admin E-mail address',
    insertRemark: 'Insert Remark',
    messageExportError: 'No feedbacks for this period',
    pageTitle: 'Customer Satisfaction for',
    pending: 'Pending',
    placeholderStatusClosed: 'Write here your remark about the comment…',
    placeholderStatusForwarded: 'Write here your suggestion to admin office',
    placeholderStatusUnderProcess: 'Write here your remark about the comment…',
    processing: 'Processing',
    remarkedBy: 'Remarked by',
    reviewed: 'Reviewed',
    ride: 'ride',
    see: 'See',
    statusChanged: 'Feedback status changed',
    suggestion: 'Suggestion',
    timePeriod: 'Time period',
  },
  invoice: {
    agencyDriver: 'Agency Driver',
    bookedBy: 'Booked by',
    charges: 'Charges',
    comments: 'Comments',
    createInvoice: 'Create Invoice',
    departureTime: 'Departure Time',
    fullTripDetails: 'Full Trip Details',
    greenFundIncluded: 'Green fund included',
    individualInvoiceCreatedTitle: 'The Individual Invoice is created and an email will be sent',
    individualInvoiceFor: 'Individual Invoice for',
    individualInvoiceListTitle: 'Select Individual Invoice',
    inputInvoiceSearchByPaxAgency: 'Search by Pax Agency or Passenger',
    inputSearchByInvoiceNumber: 'Search by Invoice Number',
    insertComment: 'Insert Comment',
    invoiceCreated: 'Invoice created successfully',
    invoiceCreatedModalGreeting: 'You are creating a new invoice',
    invoiceFor: 'Invoice for',
    invoiceHistory: 'Invoice History',
    invoiceListTitle: 'Select booking from location',
    invoiceNumber: 'Invoice Number',
    invoiceTotal: 'Invoice Total',
    issueDate: 'Issue Date',
    messageInvoiceUpdated: 'Invoice was updated',
    messageDriveDeleted: 'Drive was deleted',
    pageTitle: 'Please, fill in the form for the locations',
    passengerDetails: 'Passenger Details',
    paxNumber: 'Pax Number',
    purpose: 'Purpose',
    quantity: 'Quantity',
    requestUnit: 'Request Unit',
    sendCopy: 'Send Copy to',
    totalAmount: 'Total amount',
    tripsDetails: 'Trips Details',
    viewInvoice: 'View Invoice',
  },
  mobility: {
    assignedTo: 'Assigned to',
    bloodGroup: 'Blood Group',
    btnConnected: 'Connected',
    btnConnectToGPS: 'Connect to GPS',
    btnDisconnect: 'Disconnect',
    btnGoToChecklist: 'Go To Checklist',
    btnMarkAvailable: 'Mark as Available',
    btnMarkUnavailable: 'Mark as Unavailable',
    btnSaveSettings: 'Save Settings',
    carInfo: 'Car Info',
    chassisNumber: 'Chassis Number',
    checklistCompletedByDriver: 'From the checklist completed by the driver',
    clear: 'Clear',
    costPreviewByVehicleType: 'Cost Preview by vehicle type',
    critical: 'Critical',
    criticalIssue: 'Critical Issue',
    dailyChecks: 'Daily checks',
    driverLicense: 'Driver License',
    driversListTitle: 'Drivers for',
    editDriver: 'Edit Driver',
    editVehicle: 'Edit Vehicle',
    expirationDate: 'Expiration Date',
    externalProvider: 'External Provider',
    filterByDriver: 'Filter by Driver',
    filterByPassengerLastName: 'Filter by Passenger Last Name',
    filterByVehicle: 'Filter by Vehicle',
    fleetCostsSettings: 'Fleet Costs Settings',
    forVehicle: 'For the vehicle',
    inputAverageKmPerHour: 'Average km/hour',
    inputBuffer: 'Buffer',
    inputCarpooling: 'Carpooling',
    inputCost: 'Cost',
    inputDiesel: 'Diesel/lt',
    inputDriverGrossSalary: 'Driver Gross salary / year',
    inputEmissionDiesel: 'Diesel kg CO2e/liter',
    inputEmissionPetrol: 'Petrol kg CO2e/liter',
    inputGlobal: 'Global',
    inputPerHour: 'Per Hour',
    inputPerKmDiesel: 'Per km (Diesel)',
    inputPerKmPetrol: 'Per km (Petrol)',
    inputPetrol: 'Petrol/lt',
    issues: 'Issues',
    issuesTextVehicleCanStart:
      'The following issues are present but the vehicle can start a new drive',
    issuesTextBeforeStarting:
      'The following issues are present and some of them need to be solved before starting a new drive',
    lastModified: 'Last modified on',
    location: 'Location',
    messageDateError: 'The date is not valid. Refresh the page, please',
    messageDriveCancel: 'Drive was canceled',
    messageDriveCostsUpdated: 'Drive Costs was updated',
    messageDrivePublished: 'Drive was published',
    messageDrivesPublished: 'Drives were published',
    messageDriverUpdated: 'Driver was successfully updated',
    messageShareArmoured: 'Is not possible to share armoured vehicles',
    messageUpdateDrive: 'Drive was updated',
    messageVehicleUpdated: 'Vehicle was successfully updated',
    mobilityLogbook: 'Mobility Logbook',
    myDrivers: 'My Drivers',
    myVehicles: 'My Vehicles',
    noCostSettings: 'No cost settings',
    notReported: 'Not reported',
    notUsed: 'Not used',
    oneDay: 'One Day',
    otherIssues: 'other issues',
    overviewFor: 'Overview for',
    owned: 'Owned',
    personalInfo: 'Personal Info',
    plateNumber: 'Plate Number',
    preferredDriver: 'Preferred Driver',
    preferredVehicle: 'Preferred Vehicle',
    rented: 'Rented',
    roofNumber: 'Roof Number',
    selectDriver: 'Select Driver',
    selectVehicle: 'Select Vehicle',
    selectWhen: 'Select when',
    selectWhy: 'Select why and when the',
    serviceCostSettingsTitle: 'Service Cost Settings for',
    sharedWith: 'Shared With',
    skinType: 'Skin Type',
    statusExistMessage: 'for these dates before making unavailable',
    statusExistWarning: 'is unavailable for these dates',
    totalKm: 'Total Km',
    unavailable: 'Unavailable',
    vehicleModel: 'Vehicle Model',
    vehicleOwner: 'Vehicle Owner',
    vehicleReasonRegularMaintenance: 'Regular Maintenance',
    vehicleReasonExtraordinaryRepair: 'Extraordinary Repair',
    vehicleReasonForDisposal: 'Unavailable - For disposal',
    vehicleReasonDifferentLocation: 'Unavailable - To a different location',
    vehicleType: 'Vehicle Type',
    vehiclesChecklist: 'Vehicles Checklist',
    vehiclesListTitle: 'Vehicles for',
    willBeUnavailable: 'will be Unavailable',
  },
  planner: {
    addLeg: 'Add leg',
    createDrive: 'Create Drive',
    driveReadOnly: 'Drive (read only)',
    driveScheduledFor: 'Drive scheduled for',
    dropOff: 'Drop Off',
    focalPoint: 'Focal Point',
    justReadOnly: 'Just read-only',
    mainInfo: 'Main Info',
    messageCancelDriveConfirm: 'Are you sure you want to cancel drive?',
    messageConflictingDrives: 'Selected driver has already drives with another vehicle',
    messageConflictingDrivesEdit:
      'Please check the dates and time to ensure that are correctly selected for all trips in this booking.',
    messageDriveVerified: 'Press confirm button to proceed with your changes',
    messageOverlappingDrives:
      'Submitted legs overlap each other. Please, specify a different date and time',
    messageSharedDrive:
      'There is an existing drive on the planner which conflicts with the entered information. Please, specify different time, driver or vehicle',
    multiWarn1: 'Another drive already exists for the same time-slot',
    multiWarn2: 'if you want to assign vehicle and driver for current drive or',
    multiWarn3: 'to dismiss',
    noDriverInformationAvailable: 'No driver information is available',
    noPassengers: 'No passengers',
    numberOfPax: 'Number of Pax',
    pickUp: 'Pick Up',
    remarks: 'Remarks (optional)',
    returnTrip: 'Return Trip',
    titleExport: 'Export current month to PDF',
    town: 'Town',
    tripType: 'Trip Type',
    tripInfo: 'Trip Info',
  },
  report: {
    agencyPaxVsNot: 'Agency pax vs not',
    autoFilled: 'Auto-filled. Please edit if required',
    carpooledTrip: 'Carpooled trip',
    co2saving: 'CO2 savings',
    costRecoverySummary: 'Cost Recovery Summary',
    costRecoveryTitle: 'Report details for',
    countryDemand: 'Country Demand KPIs',
    countryReporting: 'Country Reporting',
    distanceTraveled: 'Distance traveled',
    durationAndDistance: 'Duration and Distance',
    editTripData: 'Edit trip data',
    efficiencySaving: 'Efficiency saving',
    errorMessageDrive: 'No drive with this id found',
    errorMessageDrives: 'No drives found',
    fleet: 'Fleet',
    inputApprovedBy: 'Approved by',
    inputCertifiedBy: 'Certified by',
    inputOdometerEnd: 'Odometer end',
    inputOdometerStart: 'Odometer start',
    inputPreparedBy: 'Prepared by',
    isDriveInFuture: 'You can only edit past trips',
    isManualEditedTooltip: 'Manually inputted trip data',
    isSyncedTooltip: 'Trip data from VTS',
    monthlyBookings: 'Monthly bookings',
    monthlyCostRecoveries: 'Monthly Cost Recoveries',
    monthlySummary: 'Monthly Summary',
    monthlyTrips: 'Monthly trips',
    monthlyTripsDistance: 'Monthly trips distance',
    monthlyTripsDuration: 'Monthly trips duration',
    performedOn: 'Performed on',
    reportDetails: 'Report Details',
    ridesharedTrip: 'Rideshared trip',
    rideSharing: 'Ride Sharing',
    summary: 'Summary',
    totalMileage: 'Total Mileage',
    totalTime: 'Total Time',
    upcomingTripsMessage: 'Upcoming trips or already invoice, trip data not editable',
  },
};
